import { Auth, I18n } from "aws-amplify";
import React, { useState } from "react";
import { MailOutlined, QrcodeOutlined } from "@ant-design/icons";
import { DmButton, DmMessage } from "dm-react-ui";

import auth_types from "../../../../assets/images/auth_types.png";
import "./mfaSelector.css";
import MfaDevice from "./MfaDevice/MfaDevice";

const MfaSelector = ({ user }) => {
  const [settingMfaApp, setSettingMfaApp] = useState(false);
  const [settingMfaEmail, setSettingMfaEmail] = useState(false);
  const [messageData, setMessageData] = useState(null);
  const [showMessage, setShowMessage] = useState(false);

  function showMessageInfo() {
    return (
      <DmMessage
        messageText={I18n.get(messageData.mText)}
        descriptionText={I18n.get(messageData.dText)}
        type={messageData.type}
        key={messageData.key || Math.random()}
        duration={messageData.duration || 5}
      />
    );
  }

  function finishRegistrer() {
    const userData = {
      username: user.username,
      attributes: user.attributes,
      userPermissions: JSON.parse(
        user.signInUserSession.idToken.payload.user_permissions
      ),
    };
    localStorage.setItem("user-profile", JSON.stringify(userData));
    setMessageData({
      type: "success",
      mText: I18n.get("Registration successful!"),
      dText: I18n.get(
        "You can now login with your new device. You will be redirected in a moment."
      ),
      key: "success-register",
      duration: 4,
    });
    setShowMessage(true);
    setTimeout(() => {
      singleSpaNavigate("/");
    }, 4000);
    // eslint-disable-next-line no-undef
  }

  const handleMfaApp = () => {
    setSettingMfaApp(true);
  };

  const handleMfaEmail = () => {
    setShowMessage(false);
    setSettingMfaEmail(true);
    finishRegistrer();
  };

  return settingMfaApp ? (
    <MfaDevice user={user} finishRegistrer={finishRegistrer} />
  ) : (
    <div>
      <img
        src={auth_types}
        alt="auth_types"
        className="dm-auth-mfa-selector-types-image"
      />
      <h1 className="dm-auth-mfa-selector-title">
        {I18n.get("How do you wish to set the Multi-factor Authentication?")}
      </h1>
      {/* <h1 className="dm-auth-mfa-selector-title">
        {I18n.get("We will help you now to set the Multi-factor Authentication.")}
      </h1> */}
      <h2 className="dm-auth-mfa-selector-subtitle">
        {I18n.get("We have set SMS as default option.")}
      </h2>
     {/*  <h2 className="dm-auth-mfa-selector-subtitle">
        {I18n.get("This will help you to keep your account secure.")}
      </h2> */}
      <div className="dm-auth-mfa-selector-types-container">
         <div>
          <QrcodeOutlined style={{ color: "var(--sky-sky-5)", fontSize: 24 }} />
          <div className="dm-auth-mfa-selector-types-name">
            {I18n.get(
              "You will have to use a verification app like Google Authenticator, Authy or Duo."
            )}
          </div>
          <DmButton
            disabled={settingMfaEmail}
            type="secondary"
            className="dm-auth-secondary-button"
            onClick={handleMfaApp}>
            {I18n.get("Continue to set an MFA App")}
          </DmButton>
        </div>
        <div>
          <MailOutlined style={{ color: "var(--sky-sky-5)", fontSize: 24 }} />
          <div className="dm-auth-mfa-selector-types-name">
            {I18n.get(
              "When login, you will receive an SMS to your phone with the verification code."
            )}
          </div>
          <DmButton
            onClick={handleMfaEmail}
            loading={settingMfaEmail}
            disabled={settingMfaEmail}
            type="secondary"
            className="dm-auth-secondary-button">
            {settingMfaEmail
              ? I18n.get("Redirecting")
              : I18n.get("Continue with SMS")}
          </DmButton>
        </div>       
      </div>
      {showMessage && showMessageInfo()}
    </div>
  );
};

export default MfaSelector;
